import { CalendarDays, Calendar, Target } from 'lucide-react'
import type { BottomNavItem } from '@/registry/types'

export const plannerBottomNav: BottomNavItem[] = [
  { id: 'today', label: 'Today', icon: CalendarDays, href: '/apps/planner?tab=today' },
  { id: 'week', label: 'Week', icon: Calendar, href: '/apps/planner?tab=week' },
  { id: 'goals', label: 'Goals', icon: Target, href: '/apps/planner?tab=goals' },
]
